/**
 * @generated SignedSource<<125d69e295fbdfeaa53769e17d7e0ac0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PersistentInviteEligibleQuery_space$data = {
  readonly currentUser: {
    readonly isAnonymouslyAuthorized: boolean;
  };
  readonly id: string | null;
  readonly " $fragmentType": "PersistentInviteEligibleQuery_space";
};
export type PersistentInviteEligibleQuery_space$key = {
  readonly " $data"?: PersistentInviteEligibleQuery_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"PersistentInviteEligibleQuery_space">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PersistentInviteEligibleQuery_space",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "SpaceUserMetadata",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAnonymouslyAuthorized"
        }
      ]
    }
  ],
  "type": "Space"
};

(node as any).hash = "a7c9c234a13381dbf5bbe25ee1058d5f";

export default node;
